import React from 'react';

// Двухцветная плашка статуса — замена одноцветному antd Tag, тот же текст
// (label), только визуальное оформление (bg/fg вместо однотонной заливки).
const Pill: React.FC<{ bg: string; fg?: string; children: React.ReactNode; style?: React.CSSProperties }> = ({
  bg, fg, children, style,
}) => (
  <span style={{
    display: 'inline-block', padding: '3px 10px', borderRadius: 4,
    fontSize: 11, fontWeight: 700, background: bg, color: fg,
    width: 'fit-content', lineHeight: 1.6, ...style,
  }}>
    {children}
  </span>
);

export default Pill;
